export const headwearLandingPages = [
  {
    key: 'printed-caps',
    path: '/headwear/printed-caps',
    navLabel: 'כובעים להדפסה',
    eyebrow: 'כובעים / הדפסה',
    backgroundWord: 'הדפס',
    title: 'כובעים להדפסה',
    description:
      'כובעים להדפסה למותגים, צוותים, אירועים וחלוקה בכמויות. בוחרים דגם מתאים, ממשיכים לדף המוצר ומשם מעלים עיצוב או סוגרים איתנו את הכמות.',
    pageGoal:
      'לתת לעולם "הדפסה על כובעים" דף שנשאר במסלול ההדפסה בלבד, בלי לערבב אותו עם רקמה, כובעי טמבל או כיפות.',
    visualThesis:
      'Poster-like composition with sharp cap fronts, cobalt and ember accents, and a fast commercial feel.',
    heroPoints: [
      'חזית ברורה ללוגו ולהדפס',
      'מעבר ישיר לדפי מוצר רלוונטיים',
      'שומר על הפרדה מרקמה, טמבל וכיפות',
    ],
    spotlight: [
      {
        title: 'מתאים כשהמיתוג צריך לעבוד מהר',
        body: 'אירוע, צוות, חלוקה, או קמפיין קצר שבו צריך להגיע מהר לבחירת דגם ולהעלאת קובץ.',
      },
      {
        title: 'פחות חיפוש, יותר התאמה',
        body: 'במקום להציג את כל עולם כיסויי הראש, הדף הזה מצמצם רק לכובעים שעובדים טוב לשפת החיפוש הזאת.',
      },
      {
        title: 'שומר על שפת הקמפיין',
        body: 'מי שחיפש הדפסה על כובעים מקבל מסר ממוקד, ולא דף מעורבב עם טמבל, לגיונר או כיפות.',
      },
    ],
    workflow: [
      {
        title: 'בוחרים דגם',
        body: 'פותחים את דף הדגם כדי לראות את הצבעים ואפשרויות המיתוג שלו.',
      },
      {
        title: 'בוחרים צבע וכמות',
        body: 'בדף המוצר בוחרים צבעים, מזינים כמות לכל צבע ובוחרים אזור הדפסה מתוך האפשרויות של הדגם.',
      },
      {
        title: 'מצרפים עיצוב',
        body: 'מעלים קובץ לאזור ההדפסה שנבחר, מוסיפים הערות לפי הצורך ובודקים את הסיכום לפני ההוספה לעגלה.',
      },
    ],
    bulkTitle: 'יש כמות? עדיף לסגור קודם את הסילואט הנכון',
    bulkBody:
      'בעבודות בכמות, ההחלטה הראשונה היא לא הצבע אלא סוג הכובע. אחרי שבוחרים את הבסיס הנכון, הרבה יותר קל להתקדם למיתוג, לכמויות ולמחיר.',
    bulkPoints: [
      'חלוקה לצוותים או ימי מותג',
      'אירועים שצריכים חזית מיתוג ברורה',
      'מעבר מהיר לבחירת דגם לפני התאמות',
    ],
    closingNote:
      'אם כוונת החיפוש היא הדפסה על כובעים, זה צריך להיות הדף הראשון שרואים. אחר כך אפשר לרדת לפרטי המוצר.',
    primaryCta: { label: 'לבחירת צבע וכמות ב־KR2020', to: '/product/KR2020' },
    secondaryCta: { label: 'לשיטות המיתוג', to: '/methods-of-branding' },
    finalCta: { label: 'להגדיר את הכובעים וההדפס', to: '/product/KR2020' },
    finalSecondaryCta: { label: 'דברו איתנו על כמויות', to: '/contact' },
    catalogPath: '/catalog?filter=headwear&headwearType=classic_baseball',
    theme: {
      heroStart: '#7a00ff',
      heroEnd: '#fe00ff',
      surface: '#f8fbff',
      accent: '#2563eb',
      muted: '#dbeafe',
      ink: '#0f172a',
    },
    featuredSkus: ['KR2210', 'KR2020', 'KR2211'],
    surfacedSkus: ['KR2020', 'KR2210', 'KR2211', 'KR2220'],
    productReasons: {
      KR2020: 'בסיס טוב לקו כובעים רחב, עם חזית ברורה ומבחר צבעים רחב.',
      KR2210: 'דגם נקי ומסודר יותר, מתאים כשצריך מראה מעט מדויק יותר בלי להסתבך.',
      KR2211: 'כובע רשת שנותן אופי קליל יותר ועדיין נשאר בתוך עולם הכובעים להדפסה.',
      KR2220: 'מכניס אופציית ספורט קלה בתוך הקו הכללי, בלי לפתוח כרגע קטגוריית dry-fit נפרדת.',
    },
  },
  {
    key: 'embroidered-caps',
    path: '/headwear/embroidered-caps',
    navLabel: 'כובעים לרקמה',
    eyebrow: 'כובעים / רקמה',
    backgroundWord: 'רקמה',
    title: 'כשצריך מיתוג שיישב כמו חלק מהכובע, לא כמו תוספת',
    description:
      'דף כניסה לקו הרקמה על כובעים. הוא מציג דגמים עם מראה ייצוגי יותר, ומתאים לצוותים, מתנות מותג וקווי לבוש קבועים.',
    pageGoal:
      'לתת לקו הרקמה דף שקט ומדויק יותר, עם בחירה בדגמים שנראים נכון למסר ייצוגי.',
    visualThesis:
      'Graphite, stone, and warm sand. More tailored and composed than the print page, with premium-feeling spacing.',
    heroPoints: [
      'בחירה בדגמים שנראים ייצוגיים יותר',
      'כניסה נוחה לצוותים ולמיתוג קבוע',
      'שומר מרחק ממסר של חלוקה זולה או גימיק',
    ],
    spotlight: [
      {
        title: 'נכון לצוותים ולעובדים קבועים',
        body: 'כשמחפשים כובע שנראה חלק מהנראות של המותג, דף הכניסה הזה עושה את הסינון הראשוני בשבילכם.',
      },
      {
        title: 'לא כל כובע צריך להוביל כאן',
        body: 'ריכזנו דגמים שנראים מדויק יותר לעולם הרקמה, במקום להראות את כל מה שיש בקטלוג.',
      },
      {
        title: 'מתאים גם למתנות ממותגות',
        body: 'עמוד הכניסה הזה עובד טוב גם למיתוג שמחפש תחושה מסודרת, לא רק מחיר.',
      },
    ],
    primaryCta: { label: 'לצפייה בדגמי הכובעים', to: '/catalog?filter=headwear&headwearType=classic_baseball' },
    secondaryCta: { label: 'לדבר על התאמת שיטה', to: '/contact' },
    finalCta: { label: 'לצפייה בדגמים המתאימים', to: '/catalog?filter=headwear&headwearType=classic_baseball' },
    finalSecondaryCta: { label: 'לשיטות המיתוג', to: '/methods-of-branding' },
    catalogPath: '/catalog?filter=headwear&headwearType=classic_baseball',
    theme: {
      heroStart: '#1f2937',
      heroEnd: '#b08968',
      surface: '#f8f5f1',
      accent: '#b08968',
      muted: '#ebe5dc',
      ink: '#111827',
    },
    featuredSkus: ['OM6110', 'KR2210', 'OM6157'],
    surfacedSkus: ['KR2210', 'OM6110', 'OM6157', 'KR2020'],
    productReasons: {
      KR2210: 'כובע מצחייה איכותי עם נראות נקייה שמתאימה לקו ייצוגי יותר.',
      OM6110: 'דגם דו-צבעי עם אופי אופנתי יותר, טוב כשלא רוצים להיראות כמו חלוקת קד"מ.',
      OM6157: 'מוסיף לקו הרקמה אופציה מעט יותר מעוצבת בלי לעזוב את עולם הכובעים הקלאסיים.',
      KR2020: 'הבחירה הפרקטית בתוך הדף, למי שצריך גם פשטות וגם נראות מסודרת.',
    },
  },
  {
    key: 'branded-caps',
    path: '/headwear/branded-caps',
    navLabel: 'כובעים ממותגים',
    eyebrow: 'כובעים / מיתוג עסקי',
    backgroundWord: 'מותג',
    title: 'כובעים ממותגים שלא מרגישים כמו גיבאוויי',
    description:
      'דף ממוקד לעסקים, צוותים, ימי מותג ומתנות. הוא מרכז את הדגמים הייצוגיים יותר בעולם הכובעים, עם מסר שמתאים למותג ולא רק למחיר.',
    pageGoal:
      'לתפוס כוונת "כובעים ממותגים" ולתרגם אותה לעמוד עסקי, לא לעמוד טכני של דגמים בלבד.',
    visualThesis:
      'Midnight and emerald palette, with more corporate calm and less campaign noise.',
    heroPoints: [
      'טוב לצוותים, דיילים ומתנות מותג',
      'דגמים ייצוגיים יותר לקו עסקי',
      'מסר עסקי ברור כבר מהמסך הראשון',
    ],
    spotlight: [
      {
        title: 'עמוד שנכתב לכוונת B2B',
        body: 'המסר כאן לא מוכר רק כובע. הוא מוכר התאמה למותג, לצוות או לאירוע עסקי.',
      },
      {
        title: 'קיבלנו את שפת החיפוש כמו שהיא',
        body: 'מי שחיפש "כובעים ממותגים" לא צריך להגיע קודם לדף כללי של כובעים או קטלוג מלא.',
      },
      {
        title: 'בחירה בדגמים שנראים נכון למותג',
        body: 'לא כל כובע בקטלוג עולה לכאן. הדף הזה מחזיק רק את הדגמים שנראים מדויק יותר לשימוש עסקי.',
      },
    ],
    primaryCta: { label: 'לצפייה בדגמים', to: '/catalog?filter=headwear&headwearType=classic_baseball' },
    secondaryCta: { label: 'להתחיל שיחה על מיתוג', to: '/contact' },
    finalCta: { label: 'לבחירת כובע ממותג', to: '/catalog?filter=headwear&headwearType=classic_baseball' },
    finalSecondaryCta: { label: 'לצפייה בעבודות', to: '/works' },
    catalogPath: '/catalog?filter=headwear&headwearType=classic_baseball',
    theme: {
      heroStart: '#052e2b',
      heroEnd: '#0f3d56',
      surface: '#f4f7f5',
      accent: '#15803d',
      muted: '#e5efe8',
      ink: '#0f172a',
    },
    featuredSkus: ['OM6110', 'KR2210', 'OM6157'],
    surfacedSkus: ['KR2210', 'OM6110', 'OM6157', 'KR2020', 'KR2211'],
    productReasons: {
      KR2210: 'הבסיס הייצוגי והמאוזן ביותר לעסקים, צוותים ופעילויות מותג.',
      OM6110: 'נותן מראה קצת יותר מעוצב, טוב כשחשוב להיראות פחות גנרי.',
      OM6157: 'נכנס לדף הזה בתור אופציה עם יותר נוכחות וסטייל.',
      KR2020: 'הגרסה הפרקטית לקו עסקי רחב יותר ובמחיר נוח יותר.',
      KR2211: 'עובד כשמחפשים גם תחושה צעירה יותר, בלי לצאת מעולם המיתוג.',
    },
  },
  {
    key: 'tembel-hats',
    path: '/headwear/tembel-hats',
    navLabel: 'כובעי טמבל',
    eyebrow: 'כובע טמבל / כובע פטרייה',
    backgroundWord: 'טמבל',
    title: 'כובעי טמבל למוסדות, קייטנות וטיולים',
    description:
      'דף ממוקד לשפת החיפוש של כובע טמבל. הוא לא מערבב את הדגמים האלה עם כובעי מצחייה או לגיונר, אלא מציג רק את מה שנכון לסילואט ולשימוש הזה.',
    pageGoal:
      'לתת לקו "כובע טמבל" כניסה ייעודית, תוך שמירה על אמת הקטלוג שבה הדגמים האלה יושבים תחת bucket.',
    visualThesis:
      'Sunlit sand and sky palette, airier spacing, and wider silhouettes that feel outdoor rather than corporate.',
    heroPoints: [
      'מתאים למוסדות, קייטנות וטיולי קיץ',
      'שפה נפרדת מכובעי מצחייה',
      'בחירה קצרה וברורה של דגמים מתאימים',
    ],
    spotlight: [
      {
        title: 'שפת השוק והקטלוג לא זהות',
        body: 'אנשים מחפשים "כובע טמבל", אבל הדגמים עצמם יושבים אצלנו תחת עולם כובעי הפטרייה. הדף הזה מגשר בין שני העולמות בלי לעוות את המוצר.',
      },
      {
        title: 'דף אחד, בלי רעש מהקטלוג הכללי',
        body: 'מי שהגיע לכאן לא צריך לראות כובעי מצחייה, כיפות או לגיונר לפני שהוא בוחר את הדגם הנכון.',
      },
      {
        title: 'נכון לכמויות ולשטח',
        body: 'זה קו אחר: יותר הצללה, יותר נוכחות קבוצתית, ופחות שפה של מיתוג עסקי ייצוגי.',
      },
    ],
    taxonomyNote:
      'ב-Printee הדגמים שמשרתים את שפת החיפוש "כובע טמבל" יושבים תחת משפחת כובעי הפטרייה. השמות בעמוד נשענים על שפת השוק, אבל בחירת המוצרים נשארת נאמנה לקטלוג.',
    primaryCta: { label: 'לצפייה בדגמי כובע טמבל', to: '/catalog?filter=headwear&headwearType=bucket' },
    secondaryCta: { label: 'לדבר על כמויות וקבוצות', to: '/contact' },
    finalCta: { label: 'לבחירת הדגם המתאים', to: '/catalog?filter=headwear&headwearType=bucket' },
    finalSecondaryCta: { label: 'לשיטות המיתוג', to: '/methods-of-branding' },
    catalogPath: '/catalog?filter=headwear&headwearType=bucket',
    theme: {
      heroStart: '#0f4c5c',
      heroEnd: '#e09f3e',
      surface: '#f9f5ec',
      accent: '#e09f3e',
      muted: '#efe7d7',
      ink: '#0f172a',
    },
    featuredSkus: ['KR2350', 'OM6500'],
    surfacedSkus: ['KR2350', 'OM6500'],
    productReasons: {
      KR2350: 'הדגם הישיר יותר לקו הטמבל: ברור, שימושי, ונכון לעבודה בכמויות.',
      OM6500: 'אופציית פרימיום יותר בתוך אותו סילואט, למי שרוצה כובע פטרייה עם יותר נוכחות.',
    },
  },
  {
    key: 'kippot-events',
    path: '/headwear/kippot-events',
    navLabel: 'כיפות לאירועים',
    eyebrow: 'כיפות / אירועים',
    backgroundWord: 'כיפות',
    title: 'כיפות לאירועים, עם מיתוג שלא מרגיש מאולתר',
    description:
      'דף כניסה לעולם הכיפות לאירועים. הוא מתאים לחיפושי כיפות ממותגות, הדפסה על כיפות וברירת דגמים לבר מצווה, חתונה או חלוקה ממותגת.',
    pageGoal:
      'לתת לעולם כיפות לאירועים עמוד כניסה רגוע, ברור וממוקד, בלי להעמיס מיד את כל הקטלוג.',
    visualThesis:
      'Calmer and more ceremonial, with centered product rhythm and less overt sales-page pressure.',
    heroPoints: [
      'מתאים לבר מצווה, חתונה וחלוקה ממותגת',
      'מוביל ישר לדגמי הכיפות הרלוונטיים',
      'ממסגר את ההזמנה כהחלטה של אירוע, לא רק של מוצר',
    ],
    spotlight: [
      {
        title: 'האירוע הוא ההקשר, לא רק השיטה',
        body: 'הדף הזה נכתב לעולם אירועים, ולכן הכניסה אליו מסודרת סביב השימוש בפועל ולא סביב רשימת מוצרים ארוכה.',
      },
      {
        title: 'שומר על מסר נקי גם בחיפוש כללי',
        body: 'גם אם מישהו חיפש "הדפסה על כיפות", הוא מקבל כאן מסר שיודע לדבר על בר מצווה, חתונה והזמנות בכמות.',
      },
      {
        title: 'הדגמים כאן מסודרים לפי התאמה לאירוע',
        body: 'סאטן ופשתן עולים קודם, ודגמים צרים יותר נשמרים כבחירה מודעת ולא כברירת מחדל.',
      },
    ],
    primaryCta: { label: 'לצפייה בכיפות לאירועים', to: '/catalog?filter=headwear&headwearType=kippot' },
    secondaryCta: { label: 'לדבר על אירוע וכמויות', to: '/contact' },
    finalCta: { label: 'לעבור לדגמי הכיפות', to: '/catalog?filter=headwear&headwearType=kippot' },
    finalSecondaryCta: { label: 'לצפייה בעבודות', to: '/works' },
    catalogPath: '/catalog?filter=headwear&headwearType=kippot',
    theme: {
      heroStart: '#14213d',
      heroEnd: '#c08b5c',
      surface: '#faf7f2',
      accent: '#c08b5c',
      muted: '#efe6d9',
      ink: '#111827',
    },
    featuredSkus: ['KR2381', 'KR2385', 'KR2382'],
    surfacedSkus: ['KR2381', 'KR2385', 'KR2382', 'KPK'],
    productReasons: {
      KR2381: 'כיפת סאטן שמייצרת כניסה נקייה וקלאסית לעולם האירועים.',
      KR2385: 'כיפת פשתן שנותנת תחושה מעט טבעית ומדויקת יותר לאירועים מסודרים.',
      KR2382: 'אופציית זאמש למי שמחפש מראה עמוק יותר אבל עדיין לא כבד מדי.',
      KPK: 'כיפת קטיפה כבחירה צרה יותר, לא כברירת המחדל של הדף.',
    },
  },
  {
    key: 'embroidered-kippot',
    path: '/headwear/embroidered-kippot',
    navLabel: 'כיפות לרקמה',
    eyebrow: 'כיפות / רקמה',
    backgroundWord: 'אירוע',
    title: 'כיפות רקומות לאירוע שלא רוצה להרגיש גנרי',
    description:
      'דף כניסה לקו הרקמה על כיפות. הוא פונה לאירועים ולבחירות אישיות יותר, עם מסר רגוע ומסודר שנשען על דגמים שמתאימים לעולם הזה.',
    pageGoal:
      'לתת לקו הכיפות הרקומות שפה מובחנת מהדפסה כללית, עם תחושת טקס ואירוע ולא עם שפת מוצר שטוחה.',
    visualThesis:
      'Deep wine, warm stone, and restrained ceremonial composition with product images treated almost like fabric swatches.',
    heroPoints: [
      'נכון יותר לאירוע עם אופי אישי',
      'בחירה שקטה ומדויקת של דגמים',
      'מסר טקסי יותר ופחות טכני',
    ],
    spotlight: [
      {
        title: 'לא עוד דף כללי של כיפות',
        body: 'העמוד הזה מיועד למי שמחפש תחושה אישית יותר, ולא רק דרך מהירה לסיים בחירה.',
      },
      {
        title: 'מוביל לדגמים שנראים נכון לטקס',
        body: 'פשתן, זאמש וסאטן מובילים כאן כי הם מתאימים טוב יותר לשפה של אירוע, שם ורקמה.',
      },
      {
        title: 'עובד גם לאירוע משפחתי וגם להזמנה ממותגת קטנה',
        body: 'כל עוד הכוונה היא מראה מסודר, אישי ומוקפד יותר, זה דף הכניסה הנכון.',
      },
    ],
    primaryCta: { label: 'לצפייה בדגמי הכיפות', to: '/catalog?filter=headwear&headwearType=kippot' },
    secondaryCta: { label: 'לדבר על התאמת שיטה', to: '/contact' },
    finalCta: { label: 'לבחירת דגם לכיפה רקומה', to: '/catalog?filter=headwear&headwearType=kippot' },
    finalSecondaryCta: { label: 'לשיטות המיתוג', to: '/methods-of-branding' },
    catalogPath: '/catalog?filter=headwear&headwearType=kippot',
    theme: {
      heroStart: '#5b2333',
      heroEnd: '#b08968',
      surface: '#faf5f1',
      accent: '#8b1e3f',
      muted: '#efe3db',
      ink: '#111827',
    },
    featuredSkus: ['KR2385', 'KR2382', 'KR2381'],
    surfacedSkus: ['KR2385', 'KR2382', 'KR2381'],
    productReasons: {
      KR2385: 'כיפת פשתן שמובילה את הדף בזכות תחושה טבעית וטקסית יותר.',
      KR2382: 'זאמש נכנס לכאן כשהמראה צריך מעט יותר עומק ונוכחות.',
      KR2381: 'סאטן נותן כניסה קלאסית ונקייה למי שמחפש קו אלגנטי יותר.',
    },
  },
];

export const headwearLandingPageMap = Object.fromEntries(
  headwearLandingPages.map((page) => [page.key, page])
);

export const headwearLandingPaths = headwearLandingPages.map((page) => page.path);
